import {useMemo} from "react";
import {useGetDashboardQuery, useGetAccount} from "~/api/requests";
import {useAccountId} from "~/hooks";

export const useRewardsProgramState = () => {
  const accountId = useAccountId();

  const {data: account} = useGetAccount({accountId}, {enabled: !!accountId});

  const activePaymentPlan = useMemo(() => account?.active_payment_plan, [account]);

  const {data} = useGetDashboardQuery(
    {
      account_id: accountId || "",
      payment_plan_id: activePaymentPlan?.payment_plan_id,
    },
    {enabled: !!activePaymentPlan}
  );
  const shouldDisplayRewardsWarning =
    !!data?.rewards_program_state?.points &&
    data.rewards_program_state.points > 0 &&
    data.rewards_program_state.program_state === "active";

  return {
    rewardsProgramState: data?.rewards_program_state,
    shouldDisplayRewardsWarning,
    history: data?.rewards_program_state?.history || [],
    planBalance: data?.amount_unpaid || 0,
    pendingAmount: data?.pending_amount || 0,
    last4Digits: data?.last_4_digits,
    paymentMethodType: data?.payment_method_type,
    activePaymentPlanId: activePaymentPlan?.payment_plan_id,
    accountId: data?.rewards_program_state?.account_id,
    daysRemainingToResolvePayment: data?.rewards_program_state?.days_remaining_to_resolve_payment,
  };
};
